// extracted by mini-css-extract-plugin
export default {"defaultCard":"zq-z","otherCards":"Aq-z","empty":"Bq-z","addNewItem":"Cq-z","disabled":"Dq-z","cardGrid":"Eq-z"};